/* eslint-disable max-len */
import constants from 'src/common/constants';

export const getDefaultPaymentMethod = (state) => state.all.find((paymentMethod) => paymentMethod.id === constants.DEFAULT_PAYMENT_METHOD);
